<template>
  <div class="modal fade" tabindex="-1" ref="modalEl">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Comprar envios extras</h5>
          <button type="button" class="btn-close" @click="close"></button>
        </div>
        <div class="modal-body">
          <p class="text-muted fs-7 mb-4">
            Os envios extras valem até o fim do ciclo atual e renovam junto com a mensalidade.
          </p>

          <div v-if="loading" class="text-center py-4">
            <span class="spinner-border spinner-border-sm"></span>
          </div>

          <div v-else-if="packages.length === 0" class="alert alert-light mb-0">
            Nenhum pacote disponível no momento.
          </div>

          <div v-else class="d-flex flex-column gap-3">
            <button
              v-for="pkg in packages"
              :key="pkg.slug"
              type="button"
              class="btn btn-outline btn-outline-primary text-start d-flex justify-content-between align-items-center"
              :disabled="purchasing"
              @click="purchase(pkg)"
            >
              <span>
                <strong>{{ pkg.label }}</strong>
                <span class="d-block text-muted fs-7">Crédito imediato após confirmação do pagamento</span>
              </span>
              <span class="fw-bold">R$ {{ formatMoney(pkg.price) }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '../../helpers/http';
import Alert from '../../helpers/alert';

export default {
  name: 'WhatsAppPackagePurchaseModal',
  emits: ['purchased', 'close'],
  data() {
    return {
      modal: null,
      loading: false,
      purchasing: false,
      packages: [],
    };
  },
  mounted() {
    this.modal = bootstrap.Modal.getOrCreateInstance(this.$refs.modalEl);
    this.$refs.modalEl.addEventListener('hidden.bs.modal', () => this.$emit('close'));
  },
  methods: {
    open() {
      this.loadPackages();
      this.modal?.show();
    },
    close() {
      this.modal?.hide();
    },
    formatMoney(value) {
      return Number(value || 0).toFixed(2).replace('.', ',');
    },
    loadPackages() {
      const placeId = this.$store.state.auth.place?.id_place;
      if (!placeId) {
        return;
      }

      this.loading = true;
      http.get(`/places/${placeId}/platform-subscription/whatsapp-packages`)
        .then((res) => {
          this.packages = res.data.packages || [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    purchase(pkg) {
      const placeId = this.$store.state.auth.place?.id_place;
      if (!placeId) {
        return;
      }

      this.purchasing = true;
      http.post(`/places/${placeId}/platform-subscription/whatsapp-packages/purchase`, {
        package_slug: pkg.slug,
      }).then((res) => {
        const charge = res.data.data || res.data;
        this.close();
        this.$emit('purchased', charge);
      }).catch(() => {
        Alert.error('Não foi possível iniciar a compra do pacote.');
      }).finally(() => {
        this.purchasing = false;
      });
    },
  },
};
</script>
